import gql from 'graphql-tag'

export const adminGiftSubscription = gql`
  mutation AdminGiftSubscription($input: AdminGiftSubscriptionInput!) {
    adminGiftSubscription(input: $input) {
      success
      deviceId
      deviceName
      giftMonths
      newValidTo
      oldValidTo
      emailsSent
      subscriptionId
    }
  }
`
